import { render, staticRenderFns } from "./BusinessPaymentFjdComponent.vue?vue&type=template&id=5a020b14"
import script from "./BusinessPaymentFjdComponent.vue?vue&type=script&lang=js"
export * from "./BusinessPaymentFjdComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports